import { TestTaskType } from '../constants';

export const isQuizTestTask = (testTaskType: string | null): boolean => {
  if (!testTaskType) {
    return false;
  }

  return testTaskType === TestTaskType.QUIZ;
};
